import {
  sendDeleteRequest,
  sendGetRequest,
  sendPostRequest,
  sendPutRequest,
} from "services/apiService";
import { IEventDirectoryFirestoreDoc, IEventDirectory } from "./types";

export const getEventDirectory = (directoryId: string) =>
  sendGetRequest<APIResponse<{ eventDirectory: IEventDirectoryFirestoreDoc }>>(
    `/event-directory/${directoryId}/events`,
  );

export const getCompanyEventDirectories = (companyId: string) =>
  sendGetRequest<APIResponse<{ eventDirectories: IEventDirectory[] }>>(
    `/company/${companyId}/event-directories`,
  );

export const createEventDirectory = (
  companyId: string,
  data: Partial<IEventDirectory>,
) =>
  sendPostRequest<
    typeof data,
    APIResponse<{ eventDirectories: IEventDirectory[] }>
  >(`/company/${companyId}/event-directory`, data);

export const updateEventDirectory = (
  companyId: string,
  directoryId: string,
  data: Partial<IEventDirectory>,
) =>
  sendPutRequest<
    typeof data,
    APIResponse<{ eventDirectories: IEventDirectory[] }>
  >(`/company/${companyId}/event-directory/${directoryId}`, data);

export const deleteEventDirectory = (companyId: string, directoryId: string) =>
  sendDeleteRequest<
    never,
    APIResponse<{ eventDirectories: IEventDirectory[] }>
  >(`/company/${companyId}/event-directory/${directoryId}`);
